const SAMS_SSO_URL = process.env.REACT_APP_SAMS_SSO_URL;
const SAMS_API_URL = process.env.REACT_APP_SAMS_API_URL;
const GMS_BACKEND_API_URL = process.env.REACT_APP_GMS_BACKEND_API_URL;
const DBPROMOTER_APP_URL = process.env.REACT_APP_DBPROMOTER_APP_URL;
const TASKQUEUE_WORKER_INFO_URL = process.env.REACT_APP_TASKQUEUE_WORKER_INFO_URL;
const APP_ENVIRONMENT = "DEV";
const LOGS_ENABLED = true;
const APP_NAME = "GMS Frontend";
const APP_CODE = "GMS";
const ARS_PROMOTION_API_URL = process.env.REACT_APP_ARS_PROMOTION_API_URL;
const ISR_BACKEND_URL = process.env.ISR_BACKEND_URL ?? "https://isr-api-sbp-test.compatio.net/";
const ISR_RUNTIME_URL = process.env.ISR_RUNTIME_URL ?? "https://sb3-test-sbp.compatio.net/";

const gmsConfig = {
  GMS_BACKEND_API_URL: GMS_BACKEND_API_URL,
  PROMOTION_API: ARS_PROMOTION_API_URL,
  APP_ENVIRONMENT: APP_ENVIRONMENT,
  LOGS_ENABLED: LOGS_ENABLED,
  SAMS_SSO_URL: SAMS_SSO_URL,
  SAMS_API_URL: SAMS_API_URL,
  APP_NAME: APP_NAME,
  DBPROMOTER_APP_URL: DBPROMOTER_APP_URL,
  TASKQUEUE_WORKER_INFO_URL: TASKQUEUE_WORKER_INFO_URL,
  APP_CODE: APP_CODE,
  ISR_BACKEND_URL,
  ISR_RUNTIME_URL
}

export default gmsConfig;
